import {createAction, createAsyncAction} from 'typesafe-actions';
import {IElection, IInputVoting, IPlate, IPlateDetail, IVoting} from './types';

export const clearData = createAction('@ELECTION/CLEAR_DATA')();
export const clearModel = createAction('@ELECTION/CLEAR_MODEL')();

export const loadModelAsync = createAsyncAction(
  '@ELECTION/LOAD_MODEL_REQUEST',
  '@ELECTION/LOAD_MODEL_SUCCESS',
  '@ELECTION/LOAD_MODEL_FAILURE',
  '@ELECTION/LOAD_MODEL_CANCEL'
)<void, IElection, string, void>();

export const loadPlatesAsync = createAsyncAction(
  '@ELECTION/LOAD_PLATES_REQUEST',
  '@ELECTION/LOAD_PLATES_SUCCESS',
  '@ELECTION/LOAD_PLATES_FAILURE',
  '@ELECTION/LOAD_PLATES_CANCEL'
)<void, IPlate[], string, void>();

export const setVotedPlate = createAction('@ELECTION/SET_VOTED_PLATE')<
  string
>();

export const loadPlateDetailAsync = createAsyncAction(
  '@ELECTION/LOAD_PLATE_DETAIL_REQUEST',
  '@ELECTION/LOAD_PLATE_DETAIL_SUCCESS',
  '@ELECTION/LOAD_PLATE_DETAIL_FAILURE',
  '@ELECTION/LOAD_PLATE_DETAIL_CANCEL'
)<string, IPlateDetail, string, void>();

export const requestVotingAsync = createAsyncAction(
  '@ELECTION/VOTING_REQUEST',
  '@ELECTION/VOTING_SUCCESS',
  '@ELECTION/VOTING_FAILURE',
  '@ELECTION/VOTING_CANCEL'
)<IInputVoting, IVoting, string, void>();

export const requestVotingClear = createAction('@ELECTION/VOTING_CLEAR')();



// WEBPACK FOOTER //
// ./src/features/election/store/actions.ts